import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  root: {
    padding: 25,
  },
  section: {
    border: '1px solid black',
    padding: '20px',
    margin: '10px 0',
  },
  dealerSelect: { marginTop: 30, marginLeft: 35, width: 200 },
  dealerTypography: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '50vh',
  },
  dealerSettingsCard: {
    height: 'auto',
    width: 'auto',
    padding: 20,
    marginTop: 50,
    marginLeft: 35,
    marginRight: 35,
  },
  cardContent: { marginTop: 30 },
  campaignIdentifierTextField: {
    width: 400,
    marginRight: 60,
  },
  prependRadioButtonContainer: {
    marginLeft: 50,
  },
  prependRadioButton: { marginRight: 50 },
  mailshakeEmailContainer: { width: 400, marginTop: 30 },
  detectCampaignSwitchContainer: { marginTop: 30 },
  detectCampaignSwitch: { marginBottom: 10 },
  actionButtonContainer: {
    float: 'right',
    marginRight: 5,
    marginTop: 35,
    marginBottom: 20,
  },
  createCheckbox: { marginRight: 'auto', marginTop: '20px' },
  buttonSave: {
    color: 'white !important',
    marginLeft: '20px !important',
    marginTop: '20px !important',
  },
  buttonMap: { color: 'white !important', marginLeft: '20px !important' },
  crmSettingsCard: {
    height: 'auto',
    width: 'auto',
    padding: 20,
    marginTop: 50,
    marginLeft: 35,
    marginRight: 35,
  },
  radioButtonContainer: {
    marginTop: 30,
    width: 200,
  },
  modalTypography: { marginBottom: 20 },
  dataTableContainer: { height: 400, width: '100%', marginBottom: 30 },
  modalActionButtonContainer: {
    display: 'flex',
  },
  modalCancelButton: {
    color: 'white !important',
    marginLeft: 'auto !important',
    marginTop: '20px !important',
  },
  accordion: {
    marginLeft: '30px !important',
    marginRight: '30px !important',
    marginTop: '30px !important',
    border: '1px solid',
    borderColor: 'rgba(0, 0, 0, 0.2)',
    borderRadius: '5px !important',
  },
  crmSettingsAccordion: {
    // marginLeft: '30px !important',
    // marginRight: '30px !important',
    // marginTop: '30px !important',
    border: '1px solid',
    borderColor: 'rgba(0, 0, 0, 0.2)',
    borderRadius: '5px !important',
  },
});
